function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon / Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.375-1h.75a.375.375 0 0 0 .375-.375v-6.75a.375.375 0 0 0-.375-.375h-.75A.375.375 0 0 0 1-8.125v6.75A.375.375 0 0 0 1.375-1zM6.5-11.5H3.925l-1.063-1.772A1.5 1.5 0 0 0 1.575-14h-3.15a1.5 1.5 0 0 0-1.286.728L-3.925-11.5H-6.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5V.5A1.5 1.5 0 0 0-4.5 2h9A1.5 1.5 0 0 0 6 .5V-10h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zm-8.13-.909a.187.187 0 0 1 .161-.091h2.938a.187.187 0 0 1 .161.091l.546.909h-4.351zM4.5.5h-9V-10h9zM-2.125-1h.75A.375.375 0 0 0-1-1.375v-6.75a.375.375 0 0 0-.375-.375h-.75a.375.375 0 0 0-.375.375v6.75A.375.375 0 0 0-2.125-1z",
    transform: "translate(12 18)",
    style: {
      fill: "#778187"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/IconDelete.f02b318694319fc16cac1e264c4353e6.svg";
export { ForwardRef as ReactComponent };